import { createAction } from 'typesafe-actions';
import { recurseBuildCRFields } from '@smart-builder/util';
import { MainResourceHandler, RegisterPayload } from './types';

export function createUnregisterAction<TItemKey, TItemSummary, TItemBody>(
  displayName: string,
) {
  const unregister = createAction(
    `@${displayName}/unregister`,
  )<RegisterPayload>();

  const unregisterHandler: MainResourceHandler<
    TItemKey,
    TItemSummary,
    TItemBody,
    typeof unregister
  > = (state, action) => {
    // TODO special case for wizards.
    // In theory, we should be cleaning up the redux for all fields whenever we unregister. However in that case,
    // we'd have to take into account multiple registered request fragments for the same field.
    // For now, just do it for the wizards.
    const keys = Object.keys(action.payload.fragment).filter(key =>
      key.toLowerCase().endsWith('wizard'),
    );
    const newBody =
      keys.length > 0
        ? recurseBuildCRFields(state.currentBody, undefined, field => {
            if (keys.some(key => field.fieldName.startsWith(key))) {
              return undefined;
            } else {
              return field;
            }
          })
        : state.currentBody;
    return {
      ...state,
      currentBody: newBody,
      requestBodyFragments: state.requestBodyFragments.filter(
        fragment => fragment !== action.payload.fragment,
      ),
      overrides: action.payload.overrides
        ? state.overrides.filter(
            override => override !== action.payload.overrides,
          )
        : state.overrides,
      patchData: undefined,
      error: undefined,
    };
  };

  return {
    unregister,
    unregisterHandler,
  };
}
